<template>
  <div class="exam-entrance-container">
    <div class="exam-header">
      <el-row type="flex" justify="space-between">
        <el-col :span="8" class="exam-title">
          <h3></h3>
        </el-col>
        <el-col :span="8">
          <div class="goback"></div>
        </el-col>
      </el-row>
    </div>

    <div class="exam-entrance-main">
      <div class="exam-entrance-wrapper">
        <div class="examinfo-content">
          <div class="left">
            <div class="icon-svg exam">
              <img class="icon" v-if="types === 'exam'" src="/static/img/icon_ks.png" />
              <img class="icon" v-else src="/static/img/icon_lx.png" />
            </div>
          </div>
          <div class="right">
            <p class="sub">
              <span>{{ examInfo.name }}</span>
            </p>
            <div class="operate">
              <span class="time" v-if="examInfo.examDateTime && types == 'exam'">{{ examInfo.examDateTime }}&nbsp;</span>
              <span class="time" v-if="examInfo.examTime">{{ examInfo.examTime }}{{ types == "exam" ? "分钟" : "" }}</span>
            </div>
            <div class="count">
              <template v-for="li in sortList">
                <div class="item" :key="li.text">
                  <span class="tips">{{ li.text == "总题数" ? "练习总题" : li.text }}</span>
                  <span class="total">
                    {{ li.value }}<span class="unit">{{ li.unit }}</span>
                  </span>
                </div>
              </template>
            </div>
            <div class="btns" v-if="examInfo.batchId && types === 'exam'">
              <dsf-button size="small" type="plain" title="考生须知" @click="getRules"> 考生须知 </dsf-button>
            </div>
          </div>
        </div>
        <div class="user-form">
          <el-form ref="loginform" :model="form" label-width="100px" size="small">
            <template v-for="(item, index) in sortReserved">
              <UserFormItem
                :modelvalue="form[item.fields_value]"
                :rules="rules[item.fields_value]"
                :key="item.fields_value"
                :formItem="item"
                :itemIndex="index"
                :sexSetting="sexSetting"
                :hasphoto="hasphoto"
                @set-value="setValue"
              ></UserFormItem>
            </template>
            <el-form-item v-if="reserved.length > 0">
              <div class="button-nav">
                <dsf-button @click="submitForm('loginform')">进入{{ types == "exam" ? "考试" : "练习" }}</dsf-button>
                <dsf-button class="ds-button plain" @click="resetForm('loginform')">重置</dsf-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserFormItem from "../components/UserFormItem.vue";
export default {
  name: "DsfExamEntranceNew",
  components: { UserFormItem },
  data() {
    // 校验手机号码
    var phoneReg = /^1(3|4|5|7|8|9|6)\d{9}$/;
    var validatePhone = (rule, value, callback) => {
      if (rule.required || value) {
        if (!value) {
          return callback(new Error("该项必须填写"));
        }
        if (!phoneReg.test(value)) {
          callback(new Error("手机号码格式错误"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };

    //身份证(15位)
    const isIDCard1 = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$/;
    //身份证(18位)
    const isIDCard2 = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
    var validateIdCard = (rule, value, callback) => {
      if (rule.required || value) {
        if (!value) {
          return callback(new Error("该项必须填写"));
        }
        if (!isIDCard1.test(value) && !isIDCard2.test(value)) {
          // if (!dsf.idCode(value).type) {
          callback(new Error("身份证格式错误"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      types: "",
      form: {},
      sexSetting: [
        { value: "0", text: "男" },
        { value: "1", text: "女" },
      ],
      dialogVisible: false,
      examInfo: {},
      rules: {},
      reserved: [],
      rulesSetting: {
        email: {
          type: "email",
          message: "邮箱格式错误",
          trigger: ["blur", "change"],
        },
        phone: { validator: validatePhone, trigger: "blur" },
        // photo: [{ required: true, message: "请选择头像", trigger: "change" }],
        idcard: { validator: validateIdCard, trigger: "blur" },
      },
      hasphoto: false,
    };
  },
  computed: {
    sortReserved() {
      var list = this.reserved;
      list.sort((item, ele) => {
        return item["ds_order"] - ele["ds_order"];
      });
      return list;
    },

    sortList() {
      if (this.examInfo.list) {
        var list = this.examInfo.list;
        var first = [];
        if (list) {
          this.examInfo.list.forEach((element, _index) => {
            if (element.text === "考试总分") {
              first.push(element);
              list.splice(_index, 1);
            }
          });
        }
        return first.concat(list);
      } else {
        return [];
      }
    },
  },
  created() {
    var { trainingId, manageId } = this.$route.query;
    if (manageId && !trainingId) {
      this.getReservedByBusinessId({ businessId: manageId, types: "0" });
      this.getPublicManageInfo({ manageId });
      this.types = "exam";
    }
    if (trainingId && !manageId) {
      this.getReservedByBusinessId({ businessId: trainingId, types: "1" });
      this.getPublicManageInfo({ trainingId });
      this.types = "training";
      document.title = "练习入口";
    }
  },
  mounted() {},
  methods: {
    getRules() {
      this.$openDialog({
        title: "考试须知",
        width: "700px",
        height: "650px",
        overflow: "auto",
        footerAlign: "center",
        params: {
          path: "exam/manage/examinfo?batchId=" + this.examInfo.batchId,
        },
        btns: [
          {
            text: "确定",
            handler: (res) => {
              res.$dialog.close();
            },
          },
        ],
      });
    },

    setValue(name, value) {
      this.form[name] = value;
    },

    //公开预留信息
    getReservedByBusinessId(params) {
      var loading = dsf.layer.loading();
      this.$http
        .get("manageReseved/getReservedFields", params, $$webRoot.exam)
        .done((res) => {
          if (res.success) {
            if (res.data?.length > 0) {
              this.$nextTick(() => {
                this.reserved = [...res.data];
                [...res.data].forEach((ele, ele_index) => {
                  //设置验证规则
                  if (ele.field_property_value != "0") {
                    this.$set(this.rules, ele.fields_value, []);
                    //设置基础验证规则
                    if (ele.field["dsfa_mm.controls"].value == "dsf.textbox") {
                      this.rules[ele.fields_value].push({
                        message: "该项必须填写",
                        trigger: "blur",
                      });
                    } else {
                      this.rules[ele.fields_value].push({
                        message: "该项必须填写",
                        trigger: "change",
                      });
                    }

                    if (ele.field_property_value === "1") {
                      this.$set(this.rules[ele.fields_value][0], "required", true);
                    } else {
                      this.$set(this.rules[ele.fields_value][0], "required", false);
                    }

                    //设置特定验证规则
                    for (var rule in this.rulesSetting) {
                      if (ele.fields_value == rule) {
                        this.rules[ele.fields_value].push(this.rulesSetting[rule]);
                      }
                    }
                  }
                  //设置提交表单信息
                  if (ele.field_property_value == "0") {
                    this.reserved = this.reserved.filter((item) => {
                      return ele.fields_value != item.fields_value;
                    });
                  } else {
                    this.setForm(ele.fields_value, ele.field["dsfa_mm.controls"].value);
                  }
                });
                // console.log(this.rules);
                // console.log(this.form);
                //头像置顶
                this.reserved.forEach((item, _index) => {
                  if (item.field["dsfa_mm.controls"].value == "dsf.uploadphoto") {
                    this.$set(this.reserved[_index], "ds_order", -3);
                    this.hasphoto = true;
                  }
                  if (item.fields_value == "name") {
                    this.$set(this.reserved[_index], "ds_order", -2);
                  } else if (item.fields_value == "phone") {
                    this.$set(this.reserved[_index], "ds_order", -1);
                  }
                });
              });
            }
          } else {
            dsf.layer.message(res.message || "请求异常", false);
          }
        })
        .error((err) => {
          dsf.layer.message((err && err.message) || "请求异常", false);
        })
        .always(() => {
          dsf.layer.closeLoading(loading);
        });
    },
    //set form
    setForm(name, type) {
      this.$set(this.form, name, null);
      if (type.indexOf("dsf.radiobox") > -1) {
        this.$set(this.form, name + "_text", null);
        this.$set(this.form, name + "_value", null);
      }
    },
    //考试信息
    getPublicManageInfo(params) {
      var loading = dsf.layer.loading();
      this.$http
        .get("/manage/getPublicManageInfo", params, $$webRoot.exam)
        .done((res) => {
          if (res.success) {
            this.$nextTick(() => {
              this.examInfo = res.data;
            });
          } else {
            dsf.layer.message(res.message || "请求异常", false);
          }
        })
        .error((err) => {
          dsf.layer.message((err && err.message) || "请求异常", false);
        })
        .always(() => {
          dsf.layer.closeLoading(loading);
        });
    },

    //重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
      // console.log(this.form);
    },
    //进入考试
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.rules.photo && this.rules.photo[0].required) {
            if (!this.form.photo) {
              dsf.layer.message("请选择头像", false);
              return;
            }
          }
          // this.$delete(this.form, "sex");
          var formCopy = { ...this.form };
          this.$delete(formCopy, "sex");
          var user = {
            ...formCopy,
            photo: formCopy.photo ? JSON.stringify(formCopy.photo) : "",
          };
          var params = {
            businessId: this.reserved[0].business_id,
            typesText: this.reserved[0].types_text,
            typesValue: this.reserved[0].types_value,
            record: {
              ...user,
            },
          };

          this.$http
            .post(
              "/examUser/scopeUserManage",
              JSON.stringify(params),
              {
                headers: {
                  "Content-Type": "application/json",
                },
              },
              $$webRoot.exam
            )
            .done((res) => {
              if (res.success) {
                //练习考试不同处理
                if (this.types == "training") {
                  this.$router.replace(res.data);
                } else {
                  if (res.data === "1") {
                    //进入考试，练习
                    this.startTest();
                  } else if (res.data === "3") {
                    if (this.types == "exam") {
                      var url = "/pc/exam/check-exam-result?batchId=" + this.examInfo.batchId + "&manageId=" + this.examInfo.examManageId;
                      //历史记录--查看
                      this.$router.replace(url);
                    }
                  }
                }
              } else {
                dsf.layer.message(res.message || "请求异常", false);
              }
            })
            .error((err) => {
              //错误
              dsf.layer.message((err && err.message) || "请求异常", false);
            });
        } else {
          return false;
        }
      });
    },
    startTest() {
      var loading = dsf.layer.loading();
      this.$http
        .get("/manage/stepIntoManage", { batchId: this.examInfo.batchId }, $$webRoot.exam)
        .done((res) => {
          if (res.success) {
            if (this.examInfo.type === 0) {
              if (this.types == "exam") {
                var url = (url = "/pc/exam/exam?recordId=" + res.data + "&type=manage");
                this.$router.replace(url);
              }
            }
          } else {
            dsf.layer.message(res.message || "请求异常", false);
          }
        })
        .error((err) => {
          dsf.layer.message((err && err.message) || "请求异常", false);
        })
        .always(() => {
          dsf.layer.closeLoading(loading);
        });
    },
  },
};
</script>

<style></style>
